/**
 * @deprecated This file is deprecated. Import from '@starjack/utils' instead.
 */

import { API, DEFAULT_API_VERSION } from '../constants';

const dropFirstSlash = (path: string) =>
    path.startsWith('/') ? path.slice(1) : path;

/**
 * @deprecated Use urlBuilder from '@starjack/utils' instead.
 */
export const urlBuilder = (
    endpoint: string,
    path: string,
    version: string = DEFAULT_API_VERSION
) => `${API}${dropFirstSlash(endpoint)}/${version}${dropFirstSlash(path)}`;

/**
 * @deprecated Use buildSearchParams from '@starjack/utils' instead.
 */
export const buildSearchParams = (params: Record<string, unknown>): string => {
    if (params === null) return '';

    let paramString = '?';
    let paramIndex = 0;

    for (const key in params) {
        const param = params[key];
        if (key && param !== null && param !== undefined) {
            if (Array.isArray(param)) {
                const filtered = param.filter(
                    (entry) => entry !== null && entry !== undefined
                );

                if (filtered.length === 0) {
                    continue;
                }
            }

            paramString = `${paramString}${
                paramIndex > 0 ? '&' : ''
            }${key}=${params[key].toString()}`;

            paramIndex += 1;
        }
    }

    return paramString.length === 1 ? '' : paramString;
};
